var React = require('react');

function IcRouter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M40.33 11.81L42 10.13C39.24 7.38 35.62 6 32 6C28.38 6 24.76 7.39 22 10.13L23.66 11.79C25.97 9.5 28.98 8.35 32 8.35C35.02 8.35 38.03 9.51 40.33 11.81ZM38.67 13.33C36.83 11.49 34.42 10.57 32 10.57C29.58 10.57 27.17 11.49 25.33 13.33L26.99 14.99C28.38 13.62 30.18 12.93 32 12.93C33.81 12.93 35.62 13.62 36.99 15L38.67 13.33ZM38 26H34V18H30V26H10C7.79 26 6 27.79 6 30V38C6 40.21 7.79 42 10 42H38C40.21 42 42 40.21 42 38V30C42 27.79 40.21 26 38 26ZM16 36H12V32H16V36ZM23 36H19V32H23V36ZM30 36H26V32H30V36Z","fill":"black"}));
}

IcRouter.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IcRouter;

IcRouter.default = IcRouter;
